export default __webpack_public_path__ + "static/media/spaceship.d9bbb5f3.png";